import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Card } from 'react-bootstrap'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import Slide from '@material-ui/core/Slide'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

import { languageAction } from '../../store/actions'
import { useTranslation } from '../../hooks'
import { APP_HELPER, CONSTANTS, SUPPORTED_LANG } from '../../utils'

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />
})

function LanguagePopup() {
	let dispatch = useDispatch()
	const translate = useTranslation()
	const { openLangPopup } = useSelector((state) => state.action)
	const { locale } = useSelector((state) => state.Intl)

	const [open, setOpen] = useState(openLangPopup)

	useEffect(() => {
		setOpen(openLangPopup)
		if (locale) {
			let htmlEl = document.querySelector('html')
			htmlEl.setAttribute('lang', locale)

			let lang_direction = APP_HELPER.GET_LANG_DIRECTION(locale)
			let bodyEl = document.querySelector('body')
			bodyEl.setAttribute('dir', lang_direction)
		}
	}, [openLangPopup, locale])

	const onCloseHandler = () => {
		setOpen(false)
		dispatch(languageAction.closeLanguagePopup())
	}

	const DialogTitle = (props) => {
		// eslint-disable-next-line no-unused-vars
		const { children, classes, onClose, ...other } = props
		return (
			<MuiDialogTitle disableTypography {...other}>
				{onClose ? (
					<IconButton aria-label="close" onClick={onClose}>
						<CloseIcon />
					</IconButton>
				) : null}
			</MuiDialogTitle>
		)
	}

	const changeLngLocale = (lang_locale) => {
		setOpen(false)

		dispatch(languageAction.updateLanguageLocale(lang_locale))

		let htmlEl = document.querySelector('html')
		// htmlEl.setAttribute("dir", direction);
		htmlEl.setAttribute('lang', lang_locale)

		let lang_direction = APP_HELPER.GET_LANG_DIRECTION(lang_locale)
		let bodyEl = document.querySelector('body')
		bodyEl.setAttribute('dir', lang_direction)

		dispatch(languageAction.closeLanguagePopup())
	}

	return (
		<div>
			<Dialog
				className="OtherPopup languageMainPopup"
				disableBackdropClick
				open={open}
				TransitionComponent={Transition}
				keepMounted
				onClose={onCloseHandler}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle
					disableTypography
					id="customized-dialog-title"
					className="langCloseIcon"
					onClose={onCloseHandler}
				></DialogTitle>
				<div className="insidelangPopup">
					<div className="otherPopupInv">
						<DialogContent>
							<DialogContentText id="alert-dialog-slide-description" component={'div'}>
								<span className="suggestedHeadingText">
									{translate('LANG.SUGGESTED_LANG_PLACEHOLDER')}
								</span>
								<div className="dropdownAccordion">
									<div className="customRadio shippingCustomRadio">
										<div className="dropdownAccordion">
											<div className="customRadio shippingCustomRadio">
												{SUPPORTED_LANG.map((language, i) =>
													language?.lng_priority === 1 ? (
														<Card
															onClick={() => changeLngLocale(language.locale)}
															className={language.locale === locale ? 'activeShow' : ''}
															key={'languages-' + i}
														>
															<div
																className="card-header-left card-header"
																dir={CONSTANTS.LANG_DIRECTION.LTR}
															>
																<h5 className="LangName">
																	{language.language} {language.region}
																</h5>
																<h6 className="LangCountry">{language.country}</h6>
															</div>
														</Card>
													) : (
														''
													)
												)}
											</div>
										</div>
									</div>
								</div>
							</DialogContentText>
							<DialogContentText id="alert-dialog-slide-description" component={'div'}>
								<span className="suggestedHeadingText">
									{translate('LANG.REGION_SELECTION_PLACEHOLDER')}
								</span>
								<div className="dropdownAccordion">
									<div className="customRadio shippingCustomRadio">
										{SUPPORTED_LANG.map((language, i) => (
											<Card
												onClick={() => changeLngLocale(language.locale)}
												className={language.locale === locale ? 'activeShow' : ''}
												key={'region-' + i}
											>
												<div
													className="card-header-left card-header"
													dir={CONSTANTS.LANG_DIRECTION.LTR}
												>
													<h5 className="LangName">
														{language.language} {language.region}
													</h5>
													<h6 className="LangCountry">{language.country}</h6>
												</div>
											</Card>
										))}
									</div>
								</div>
							</DialogContentText>
						</DialogContent>
					</div>
				</div>
			</Dialog>
		</div>
	)
}

export default LanguagePopup
